export const releases = [
  {
    version: "2.1.10",
    date: "September 3, 2024",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.10",
    content: [
      {
        title: "patch changes",
        data: [
          "Update the input design for black and white colors.",
          "Add black and white colors support for textarea component.",
        ],
      },
    ],
  },
  {
    version: "2.1.9",
    date: "February 8, 2024",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.9",
    content: [
      {
        title: "patch changes",
        data: [
          "Update accordion component to make it possible to disable the animation.",
          "Fix select component issue while there is only one option available.",
          "Add red asterisk for required textarea component.",
          "Fix the prop-types issue for menu component.",
          "Fix classname override issue for all components while there is default props classname.",
        ],
      },
      {
        title: "docs changes",
        data: [
          "Fix spelling and grammar issues.",
          "Add controlled select example.",
        ],
      },
    ],
  },
  {
    version: "2.1.8",
    date: "December 20, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.8",
    content: [
      {
        title: "docs changes",
        data: [
          "New components: Skeleton, Gallery, Mega Menu",
          "New plugins integration: Lexical Rich Text Editor, Copy to Clipboard",
        ],
      },
    ],
  },
  {
    version: "2.1.7",
    date: "December 14, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.7",
    content: [
      {
        title: "patch changes",
        data: [
          "Add black color for <Button />, <IconButton /> and <ButtonGroup /> components.",
        ],
      },
      {
        title: "docs changes",
        data: [
          "Update the button, icon button and button group documentation pages.",
        ],
      },
    ],
  },
  {
    version: "2.1.6",
    date: "December 13, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.6",
    content: [
      {
        title: "patch changes",
        data: [
          "Improved disabled state style for input and select.",
          "Fixed input placeholder overlap with label.",
          "Fixed textarea label issue.",
          "Fixed typos in navbar theme object.",
          "Added loading state for the button.",
        ],
      },
      {
        title: "docs changes",
        data: [
          "Fixed broken links.",
          "Fixed typos.",
          "Updated button docs page.",
          "Improved Next.js integration guide.",
        ],
      },
    ],
  },
  {
    version: "2.1.5",
    date: "November 29, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.5",
    content: [
      {
        title: "patch changes",
        data: [
          "Plugins integration guides (Date Picker, Charts and Algolia Search).",
        ],
      },
    ],
  },
  {
    version: "2.1.4",
    date: "Octuber 18, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.4",
    content: [
      {
        title: "patch changes",
        data: ["Update <Button /> theme."],
      },
    ],
  },
  {
    version: "2.1.3",
    date: "Octuber 17, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.3",
    content: [
      {
        title: "patch changes",
        data: ["Fix theme issue with <Button /> component."],
      },
      {
        title: "docs updates",
        data: ["Fix typos.", "Update the design"],
      },
    ],
  },
  {
    version: "2.1.2",
    date: "September 14, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.2",
    content: [
      {
        title: "patch changes",
        data: [
          "Add native event listeners for <SpeedDialAction />",
          "Fix prop-types warning for <Badge />",
        ],
      },
      {
        title: "docs updates",
        data: ["Fix the issue with countries select example."],
      },
    ],
  },
  {
    version: "2.1.1",
    date: "August 24, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.1",
    content: [
      {
        title: "patch changes",
        data: ["Update typography types", "Fix grammer and typo issues"],
      },
      {
        title: "docs updates",
        data: [
          "Fix outlined issue on examples.",
          "Fix code issues for components demo.",
        ],
      },
    ],
  },
  {
    version: "2.1.0",
    date: "August 9, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.1.0",
    content: [
      {
        title: "minor changes",
        data: [
          "Update design for components",
          "Change the base color to gray-900 for components",
          "Fix the border issue with standard and static input variants",
        ],
      },
      {
        title: "docs updates",
        data: [
          "Add release notes page",
          "Add figma landing page",
          "Add algolia search for documentation",
          "Change the design and layout for the documentation",
        ],
      },
    ],
  },
  {
    version: "2.0.8",
    date: "August 2, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.0.8 ",
    content: [
      {
        title: "patch changes",
        data: ["Fix the export issue for components."],
      },
    ],
  },
  {
    version: "2.0.7",
    date: "July 22, 2023",
    name: "@material-tailwind/react",
    description: "Material Tailwind v2.0.7 ",
    content: [
      {
        title: "patch changes",
        data: ["Replace @heroicons/react icons with svg version of the icons."],
      },
      {
        title: "Docs Changes",
        data: [
          "Update props and theme pages and add them all together to the component page.",
        ],
      },
    ],
  },
  {
    version: "2.0.6",
    date: "July 17, 2023",
    name: "@material-tailwind/react",
    description: " ",
    content: [
      {
        title: "patch changes",
        data: [
          "Add useId hook for <Tabs />, <Checkbox />, <Radio />, <Switch /> components, this will help to use multiple of these components in a page without adding different id for each instance.",
          "Fix issue #387",
        ],
      },
    ],
  },
  {
    version: "2.0.5",
    date: "July 10, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Patch Changes",
        data: ["Update the stepper style for steps."],
      },
      {
        title: "Docs Changes",
        data: ["Update texts"],
      },
    ],
  },
  {
    version: "2.0.4",
    date: "jun 20, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Patch Changes",
        data: ["Fix the style issue for vertical tabs."],
      },
      {
        title: "Docs Changes",
        data: ["Add new examples with custom styles for components."],
      },
    ],
  },
  {
    version: "2.0.3",
    date: "Jun 20, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Patch Changes",
        data: [
          "Fix issue #362",
          "Fix issue #361",
          "Fix issue #360",
          "Fix issue #359",
        ],
      },
    ],
  },
  {
    version: "2.0.2",
    date: "Jun 13, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Patch Changes",
        data: [
          "Improve framer motion first load size, by @mobinyardim",
          "Fix chip size in documentation, by @guilhermealves18",
          "Fix missing import on documentation, by @abhidadhaniya23",
          "Remove all LOREM IPSUM texts from documentation",
        ],
      },
    ],
  },
  {
    version: "2.0.1",
    date: "May 16, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fixed",
        data: [
          "Add @heroicons/react as dependency to fix the missing dependency issue.",
          "Fix the <Badge /> proptypes issue for color.",
        ],
      },
    ],
  },
  {
    version: "2.0.0",
    date: "may 5, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Major Chages",
        data: [
          "Update Alert component. ",
          "Update Chip component.",
          "Update Avatar component.",
        ],
      },
      {
        title: "Features",
        data: [
          "Add new component Badge",
          "Add new component ButtonGroup",
          "Add new component Collapse",
          "Add new component Carousel",
          "Add new component Drawer",
          "Add new component List",
          "Add new component RatingBar",
          "Add new component Slider",
          "Add new component SpeedDial",
          "Add new component Spinner",
          "Add new component Stepper",
          "Add new component Timeline",
          "Update Checkbox component",
          "Update Menu component",
          "Update Navbar component",
          "Update ProgressBar component",
          "Update RadioButton component",
          "Update Swtich component",
          "Update Tabs component",
        ],
      },
      {
        title: "Docs Chages",
        data: [
          "Add new components documentation pages",
          "Add new examples to documentation",
          "Fix typos on documentation",
          "Add new page Form",
          "Add new page Pagination",
          "Add new page Footer",
          "Add new page Img",
          "Add new page Video",
          "Add new page Sidebar",
          "Add new page Table",
        ],
      },
    ],
  },
  {
    version: "1.4.2",
    date: "Feb 14, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Fix the path issue with withMT() config file."],
      },
      {
        title: "Docs",
        data: ["Update the monorepo guidelines for tailwind.config.js"],
      },
    ],
  },
  {
    version: "1.4.1",
    date: "July 22, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "changes",
        data: ["Update the withMT() function for tailwind configurations."],
      },
    ],
  },
  {
    version: "1.4.0",
    date: "feb 14, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "features",
        data: [
          "Add the __dirname for withMT() function by @randallhunt.",
          "Add shrink prop for <Input /> for making the floating label controlled.",
          "Add shrink prop for <Textarea /> for making the floating label controlled.",
          "Update <Menu /> component to be keyboard friendly.",
          "Update <Select /> component to make the label floated if there is a value by default.",
          "Update <Checkbox />, <Radio /> and <Switch /> components label type from string to node, it helps to pass JSX as value for the label prop.",
          "Add iconProps for <Checkbox /> and <Radio /> to make the icon container customisable.",
          "se the useMergeRefs instead of react-merge-refs.",
          "Remove the opacity changing when closing and opening the <Accordion />, it make the behavior more smooth.",
        ],
      },
      {
        title: "fix",
        data: [
          "Fix issue #290",
          "Fix issue #288",
          "Fix issue #258",
          "Fix issue #225 by @pppp606",
        ],
      },
      {
        title: "Docs Changes",
        data: [
          "Add guides for using @material-tailwind/react with Astro.",
          "Add guides for using @material-tailwind/react with Gatsby.",
          "Add guides for using @material-tailwind/react with Next.js 13 and Server Components.",
        ],
      },
    ],
  },
  {
    version: "1.2.5",
    date: "Jan 3, 2023",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: [
          "Fix issue #256",
          "Fix issue #249",
          "Fix issue #227",
          "Fix issue #165",
          "Fix issue #143",
          "Fix issue #116",
          "Fix issue #232",
          "Fix issue #213",
          "Fix issue #205",
          "Fix issue #240",
          "Fix issue #229",
          "Fix typo mistakes by @victorpatru and @Yarles404",
          "Fix the props interface issue for the home page by @Deveesh-Shetty",
        ],
      },
      {
        title: "Docs Changes",
        data: [
          "Add guides for using @material-tailwind/react with monorepo.",
          "Update the components pages and fix the import issues for code examples.",
        ],
      },
    ],
  },
  {
    version: "1.2.4",
    date: "sep 5, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Features",
        data: [
          "Add containerProps for Input component to make it easier for passing props to Input container element.",
        ],
      },
      {
        title: "Fix",
        data: [
          "Fix issue #210",
          "Fix issue #201",
          "Fix issue #198",
          "Fix Accordion auto height issue by @mldy.",
        ],
      },
      {
        title: "Docs Changes",
        data: ["Update accordion page.", "Update input props page."],
      },
    ],
  },
  {
    version: "1.2.3",
    date: "aug 9, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Fix issue #193", "Fix issue #194"],
      },
      {
        title: "Docs Changes",
        data: ["Update navbar example."],
      },
    ],
  },
  {
    version: "1.2.2",
    date: "aug 2, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Avatar circular variant not working."],
      },
    ],
  },
  {
    version: "1.2.1",
    date: "aug 2, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Fix issue #106.", "Fix the avatar theme object."],
      },
      {
        title: "Docs Changes",
        data: ["Update navbar page."],
      },
    ],
  },
  {
    version: "1.2.0",
    date: "aug 1, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Fix issue #177."],
      },
      {
        title: "features",
        data: ["Add MobileNav component for responsive Navbar collapse."],
      },
      {
        title: "updates",
        data: ["Update readme file."],
      },
      {
        title: "Docs Changes",
        data: ["Update navbar pages."],
      },
    ],
  },
  {
    version: "1.1.0",
    date: "July 29, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Updates",
        data: [
          "Update all of the dependencies to their latest versions.",
          "Rename blue-grey to blue-gray.",
          "Rename grey to gray.",
        ],
      },
      {
        title: "features",
        data: [
          "Use tailwind-merge library for merging className props for components.",
          "Add new white color for button and icon button.",
        ],
      },
      {
        title: "Fix",
        data: [
          "Fix accordion disabled state for keyboard.",
          "Fix the select option disabled state.",
          "Remove the unnecessary margin bottom from the switch label.",
          "Fix issue #169.",
          "Fix issue #144.",
        ],
      },
      {
        title: "Docs ",
        data: [
          "Refactor the documentation.",
          "Add variety of examples and use cases for all components.",
        ],
      },
    ],
  },
  {
    version: "1.0.8",
    date: "jul 22, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "features",
        data: ["Change the font-family from serif to sans for headings."],
      },

      {
        title: "Docs Changes",
        data: [
          "Refactor the documentation.",
          "Add new login card example for the card page",
        ],
      },
    ],
  },
  {
    version: "1.0.7",
    date: "jul 18, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Types definition issues."],
      },
      {
        title: "features",
        data: ["Mark as export all types definition for styling and theming."],
      },

      {
        title: "Docs Changes",
        data: [
          "Separate the props definition page from components page.",
          "Add theming guideline page for each individual component.",
        ],
      },
    ],
  },
  {
    version: "1.0.6",
    date: "jun 21, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Fix the production issue for <Select /> component"],
      },
    ],
  },
  {
    version: "1.0.5",
    date: "jun 21, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: ["Fix issue number #114"],
      },
    ],
  },
  {
    version: "1.0.4",
    date: "jun 15, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Fix",
        data: [
          "Fix issue number #105",
          "Fix issue number #84",
          "Fix issue number #81",
          "Fix issue number #78",
        ],
      },
    ],
  },

  {
    version: "1.0.3",
    date: "may 11, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "changes",
        data: [
          "Removed unused import for @material-tailwind/react/components/Dialog.",
          "Fixed the @material-tailwind/react/components/MenuCore.tsx floating issue when scrolling the page.",
        ],
      },
      {
        title: "Updates",
        data: ["Update README"],
      },
    ],
  },
  {
    version: "1.0.2",
    date: "may 11, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Updates",
        data: ["Update README"],
      },
    ],
  },
  {
    version: "1.0.1",
    date: "may 10, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "@material-tailwind/react",
        data: ["Update README"],
      },
      {
        title: "@material-tailwind/html",
        data: ["Update README"],
      },
    ],
  },
  {
    version: "1.0.0",
    date: "may 10, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "New features",
        data: ["@material-tailwind/html", "@material-tailwind/react"],
      },
      {
        title: "Note",
        data: [
          "The entire library has been changes and there is a totally new things there, please checkout the official documentation of the library for a better understanding. Material Tailwind",
        ],
      },
    ],
  },
  {
    version: "1.0.0 Beta",
    date: "may 10, 2022",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "New features",
        data: ["@material-tailwind/html", "@material-tailwind/react"],
      },
      {
        title: "Note",
        data: [
          "The entire library has been changes and there is a totally new things there, please checkout the official documentation of the library for a better understanding. Material Tailwind",
        ],
      },
    ],
  },
  {
    version: "0.3.4",
    date: "June 9, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "New features",
        data: ["Update tailwindcss to the latest version"],
      },
      {
        title: "Bug fixing",
        data: [
          "Update card header margin",
          "Reduce the input icon opacity",
          "Change the dropdown text from uppercase to capitalize",
        ],
      },
    ],
  },
  {
    version: "0.3.3",
    date: "May 28, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Bug fixing",
        data: [
          "Update indentation for the code example",
          "Rename the NavbarList component name to Nav",
          "Rename the NavbarItem component name to NavItem",
          "Update all the dependencies and dev-dependencies",
        ],
      },
    ],
  },
  {
    version: "0.3.2",
    date: "May 18, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "New features",
        data: [
          "New components are added",
          "className prop added for the components",
          "Default props are added for the components",
        ],
      },
      {
        title: "Bug fixing",
        data: ["Console errors are fixed"],
      },
    ],
  },
  {
    version: "0.3.1",
    date: "Apr 28, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Bug fixing",
        data: [
          "Solve the issue of tippy.js style sheets for popover, tooltips and dropdown component",
        ],
      },
    ],
  },
  {
    version: "0.3.0",
    date: "Apr 26, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "New features",
        data: [
          "New components: Textarea, Checkbox, Radio Button, Card Row, Card Status, Card Status Footer",
          "Update components design",
        ],
      },
      {
        title: "Bug fixing",
        data: ["Solve the issue with the tippy.js style modules"],
      },
    ],
  },
  {
    version: "0.2.0",
    date: "Apr 6, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "New features",
        data: [
          "Update components design",
          "Add new features for the components",
          "Add transparent background for components",
        ],
      },
    ],
  },
  {
    version: "0.1.1",
    date: "Mar 31, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Bug fixing",
        data: ["Solve ripple effect and css publish on npm"],
      },
    ],
  },
  {
    version: "0.1.0",
    date: "Mar 31, 2021",
    name: "@material-tailwind/react",
    description: "",
    content: [
      {
        title: "Original Release",
        data: [
          "Started project from Tailwind CSS and Material Design 2",
          "Added design from Material Design 2 using Tailwind CSS",
        ],
      },
    ],
  },
];

export default releases;
